export const Data =[
    {
        id:1,
        name:'Burgur',
        catagary:'Burgur',
        image:"https://images.pexels.com/photos/2271107/pexels-photo-2271107.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        Price:'$'
    },
    {
        id:2,
        name:'Skewer',
        catagary:'chicken',
        image:"https://images.pexels.com/photos/3026805/pexels-photo-3026805.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        Price:'$'
    },
    {
        id:3,
        name:'Pizza',
        catagary:'Pizza',
        image:"https://images.pexels.com/photos/2762939/pexels-photo-2762939.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        Price:'$'
    },
    {
        id:4,
        name:'Pepperoni Pizza',
        catagary:'Pizza',
        image:"https://images.pexels.com/photos/845802/pexels-photo-845802.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        Price:'$$'
    },
    {
        id:5,
        name:'Cheeseburger and Fries',
        catagary:'Burgur',
        image:"https://images.pexels.com/photos/2725744/pexels-photo-2725744.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        Price:'$$'
    },
    {
        id:6,
        name:'Cheese Pizza',
        catagary:'Pizza',
        image:"https://images.pexels.com/photos/1566837/pexels-photo-1566837.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        Price:'$$$'
    },
    {
        id:7,
        name:'Cooked Chicken',
        catagary:'chicken',
        image:"https://images.pexels.com/photos/2611917/pexels-photo-2611917.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        Price:'$$'
    },
    {
        id:8,
        name:'Sliced Cheese',
        catagary:'salads',
        image:"https://images.pexels.com/photos/4087609/pexels-photo-4087609.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        Price:'$'
    },
    {
        id:9,
        name:' Grilled Chicken',
        catagary:'chicken',
        image:"https://images.pexels.com/photos/106343/pexels-photo-106343.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        Price:'$$$'
    },
    {
        id:10,
        name:'Green Leafy Burgur',
        catagary:'Burgur',
        image:"https://images.pexels.com/photos/1199958/pexels-photo-1199958.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        Price:'$$$$'
    },
    
    {
        id:11,
        name:' Barbecue',
        catagary:'chicken',
        image:"https://images.pexels.com/photos/2689419/pexels-photo-2689419.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        Price:'$$$$'
    },
    {
        id:12,
        name:'French Salad',
        catagary:'salads',
        image:"https://images.pexels.com/photos/3026808/pexels-photo-3026808.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        Price:'$$'
    },
    {
        id:13,
        name:'Salads and Desserts',
        catagary:'salads',
        image:"https://images.pexels.com/photos/6959173/pexels-photo-6959173.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        Price:'$$$'
    },
    {
        id:14,
        name:'Vegetable Salad ',
        catagary:'salads',
        image:"https://images.pexels.com/photos/1152237/pexels-photo-1152237.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        Price:'$$$$'
    },
    {
        id:15,
        name:'Colorful Sliced Pizza',
        catagary:'Pizza',
        image:"https://images.pexels.com/photos/2909822/pexels-photo-2909822.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        Price:'$$$$'
    },
   
    {
        id:16,
        name:'Double Burgur',
        catagary:'Burgur',
        image:"https://images.pexels.com/photos/13998739/pexels-photo-13998739.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        Price:'$$$'
    },
    {
        id:1,
        name:'Burgur',
        catagary:'Burgur',
        image:"https://images.pexels.com/photos/2271107/pexels-photo-2271107.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        Price:'$'
    },
    {
        id:2,
        name:'Skewer',
        catagary:'chicken',
        image:"https://images.pexels.com/photos/3026805/pexels-photo-3026805.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        Price:'$'
    },
    {
        id:3,
        name:'Pizza',
        catagary:'Pizza',
        image:"https://images.pexels.com/photos/2762939/pexels-photo-2762939.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        Price:'$'
    },
    {
        id:4,
        name:'Pepperoni Pizza',
        catagary:'Pizza',
        image:"https://images.pexels.com/photos/845802/pexels-photo-845802.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        Price:'$$'
    },
    {
        id:5,
        name:'Cheeseburger and Fries',
        catagary:'Burgur',
        image:"https://images.pexels.com/photos/2725744/pexels-photo-2725744.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        Price:'$$'
    },
    {
        id:6,
        name:'Cheese Pizza',
        catagary:'Pizza',
        image:"https://images.pexels.com/photos/1566837/pexels-photo-1566837.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        Price:'$$$'
    },
    {
        id:7,
        name:'Cooked Chicken',
        catagary:'chicken',
        image:"https://images.pexels.com/photos/2611917/pexels-photo-2611917.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        Price:'$$'
    },
    {
        id:8,
        name:'Ladies Finger Salad',
        catagary:'salads',
        image:"https://images.pexels.com/photos/1247677/pexels-photo-1247677.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        Price:'$'
    },
    {
        id:9,
        name:' Grilled Chicken',
        catagary:'chicken',
        image:"https://images.pexels.com/photos/106343/pexels-photo-106343.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        Price:'$$$'
    },
    {
        id:10,
        name:'Green Leafy Burgur',
        catagary:'Burgur',
        image:"https://images.pexels.com/photos/1199958/pexels-photo-1199958.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        Price:'$$$$'
    },
    
    {
        id:11,
        name:' Barbecue',
        catagary:'chicken',
        image:"https://images.pexels.com/photos/2689419/pexels-photo-2689419.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        Price:'$$$$'
    },
    {
        id:12,
        name:'Russain Salad',
        catagary:'salads',
        image:"https://images.pexels.com/photos/2097090/pexels-photo-2097090.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        Price:'$$'
    },
    {
        id:13,
        name:'Sindhi Salad',
        catagary:'salads',
        image:"https://images.pexels.com/photos/3323687/pexels-photo-3323687.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        Price:'$$$'
    },
    {
        id:14,
        name:' Salad Bowl ',
        catagary:'salads',
        image:"https://images.pexels.com/photos/7660425/pexels-photo-7660425.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        Price:'$$$$'
    },
    {
        id:15,
        name:'Colorful Sliced Pizza',
        catagary:'Pizza',
        image:"https://images.pexels.com/photos/2909822/pexels-photo-2909822.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        Price:'$$$$'
    },
   
    {
        id:16,
        name:'Double Burgur',
        catagary:'Burgur',
        image:"https://images.pexels.com/photos/13998739/pexels-photo-13998739.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        Price:'$$$'
    },
    
];

 
  